import React from "react";
import {FormControl} from "./FormControl";
export function Checkbox({
    label,
    checked,
    onChange,
    disabled,
    className,
    labelClassName,
    id
}) {
    return (
        <FormControl controls={{type: "checkbox"}}>
            <input
                type="checkbox"
                id={id ?? label}
                disabled={disabled}
                checked={checked ?? false}
                defaultValue={checked}
                onChange={(e) => onChange(e.target.checked, e.target.id)}
                className={className ?? "skynet-input"}
            />
            <label className={labelClassName} htmlFor={id ?? label}>{label}</label>
        </FormControl>
    );
}